import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#ffffff',
        },
        secondary: {
            main: '#b5b5b5',
        },
    },
    typography: {
        // Greift auf --schrift aus globals.css zu, damit die Schrift nur an
        // einer Stelle definiert ist.
        //
        // Frueher stand hier 'Tahoma', waehrend globals.css fuer
        // .MuiTypography-root "'Segoe UI', Tahoma, sans-serif" setzte. Beide
        // Regeln haben dieselbe Spezifitaet, es entschied also die Reihenfolge
        // beim Einfuegen - welche Schrift tatsaechlich griff, war damit nicht
        // verlaesslich vorhersagbar. Jetzt zeigen beide auf denselben Wert.
        fontFamily: 'var(--schrift)',
        h1: {
            fontSize: '2.3rem',
            fontWeight: 'bold',
            color: '#8d3848'
        },
        h2: {
            fontSize: '1.9rem',
            fontWeight: 'bold',
            color: '#8d3848'
        },
        h3: {
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#8d3848'
        },
        h4: {
            fontSize: '1.3rem',
            fontWeight: 'bold',
            color: '#8d3848'
        },
        h5: {
            fontSize: '1.2rem',
            fontWeight: 'bold',
            color: '#8d3848'
        },
        h6: {
            fontSize: '1.1rem',
            fontWeight: 'bold',
            color: '#8d3848'
        },
        caption: {
            fontSize: '0.8rem',
            color: '#616161'
        },
        body1: {
            fontSize: '1.2rem',
            color: '#616161'
        },
        body2: {
            fontSize: '1rem',
            color: '#616161'
        }
    },
});

export default theme;
